/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner } from './InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner';
import {
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON,
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSONTyped,
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON,
    InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSONTyped,
} from './InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner';

/**
 * 
 * @export
 * @interface InstanceBulkDecisionRequestBidirectionalActionDetailsDetails
 */
export interface InstanceBulkDecisionRequestBidirectionalActionDetailsDetails {
    /**
     * 
     */
    selections: Array<InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>;
    /**
     * 
     */
    internal_selections?: Array<InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInner>;
    /**
     * 
     */
    date?: string;
    /**
     * 
     */
    time?: string;
    /**
     * 
     */
    message?: string;
    /**
     * 
     */
    internal_message?: string;
    /**
     * 
     */
    phone_number?: string;
    /**
     * 
     */
    phone_number_extension?: string;
    /**
     * 
     */
    checkbox?: boolean;
}

/**
 * Check if a given object implements the InstanceBulkDecisionRequestBidirectionalActionDetailsDetails interface.
 */
export function instanceOfInstanceBulkDecisionRequestBidirectionalActionDetailsDetails(value: object): value is InstanceBulkDecisionRequestBidirectionalActionDetailsDetails {
    if (!('selections' in value) || value['selections'] === undefined) return false;
    return true;
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSON(json: any): InstanceBulkDecisionRequestBidirectionalActionDetailsDetails {
    return InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkDecisionRequestBidirectionalActionDetailsDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'selections': ((json['selections'] as Array<any>).map(InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON)),
        'internal_selections': json['internal_selections'] == null ? undefined : ((json['internal_selections'] as Array<any>).map(InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerFromJSON)),
        'date': json['date'] == null ? undefined : json['date'],
        'time': json['time'] == null ? undefined : json['time'],
        'message': json['message'] == null ? undefined : json['message'],
        'internal_message': json['internal_message'] == null ? undefined : json['internal_message'],
        'phone_number': json['phone_number'] == null ? undefined : json['phone_number'],
        'phone_number_extension': json['phone_number_extension'] == null ? undefined : json['phone_number_extension'],
        'checkbox': json['checkbox'] == null ? undefined : json['checkbox'],
    };
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsToJSON(json: any): InstanceBulkDecisionRequestBidirectionalActionDetailsDetails {
    return InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsToJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsToJSONTyped(value?: InstanceBulkDecisionRequestBidirectionalActionDetailsDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'selections': ((value['selections'] as Array<any>).map(InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON)),
        'internal_selections': value['internal_selections'] == null ? undefined : ((value['internal_selections'] as Array<any>).map(InstanceBulkDecisionRequestBidirectionalActionDetailsDetailsSelectionsInnerToJSON)),
        'date': value['date'],
        'time': value['time'],
        'message': value['message'],
        'internal_message': value['internal_message'],
        'phone_number': value['phone_number'],
        'phone_number_extension': value['phone_number_extension'],
        'checkbox': value['checkbox'],
    };
}

